import { Criteria } from "./criteria";

export class FrCriteria extends Criteria {
  constructor(private displayLabelPrefix: string) {
    super();
  }

  public displayValues(values: string[]): string {
    var label = this.displayLabelPrefix + " est ";

    for (let i = 0; i < values.length - 1; i++) {
      label += this.displayValue(values[i]) + ", ";
    }

    if (values.length > 1) {
      label += " ou ";
    }

    return label + this.displayValue(values[values.length - 1])
  }

  protected displayValue(value: string): string {
    return value;
  }

}